import styled from 'styled-components'

export const Container = styled.div`
  padding: 0;
  background: #f5f5f5;
`
